import { render, staticRenderFns } from "./ftp-folders.vue?vue&type=template&id=0e7b6ba1&"
import script from "./ftp-folders.vue?vue&type=script&lang=js&"
export * from "./ftp-folders.vue?vue&type=script&lang=js&"
import style0 from "./ftp-folders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports